import { put, all, call, takeLeading, select } from 'redux-saga/effects';
import { DataState } from '@shared/enums/DataState';
import { getErrorInfo } from '@shared/helpers/getErrorInfo';
import { setCacheValue, setSignInActivitiesData } from './reducers';
import { getSignInActivities } from './actions';
import { SignInActivitiesPageData } from './types';
import { fetchSignInActivities } from '@modules/App/api/singInActivities';
import { signInActivitiesCacheSelector } from './selectors';

function* getSignInActivitiesAsync({ payload }: ReturnType<typeof getSignInActivities>) {
  try {
    const cache: ReturnType<typeof signInActivitiesCacheSelector> = yield select(signInActivitiesCacheSelector);
    if (cache[JSON.stringify(payload)]) {
      yield put(setSignInActivitiesData({ data: cache[JSON.stringify(payload)], state: DataState.Fulfilled }));
      return;
    }
    yield put(setSignInActivitiesData({ state: DataState.Pending }));
    const response: SignInActivitiesPageData = yield call(fetchSignInActivities, payload);
    yield put(setCacheValue({ key: JSON.stringify(payload), value: response }));
    yield put(setSignInActivitiesData({ data: response, state: DataState.Fulfilled }));
  } catch (e) {
    yield put(
      setSignInActivitiesData({
        data: null,
        state: DataState.Rejected,
        error: getErrorInfo(e),
      })
    );
  }
}

function* watchGetSignInActivities() {
  yield takeLeading(getSignInActivities.type, getSignInActivitiesAsync);
}

export function* signInActivitiesSaga(): Generator {
  yield all([watchGetSignInActivities()]);
}
